import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Auth uses httpOnly cookies set by the backend; `withCredentials` is what matters here.
export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const WHATSAPP_NUMBER = "447587831674";

export const PAYMENT_LINKS = {
  revolut: "https://revolut.me/olamideemmanuelojo",
  paypal: "https://paypal.me/OlamideEmmanuelOjo",
};

export const BANK_DETAILS = {
  name: "Olamide Emmanuel Ojo",
  sortCode: "23-01-20",
  accountNumber: "83223794",
  bank: "Revolut Ltd",
  address: "30 South Colonnade, E14 5HX, London",
};
